import React, { useEffect, useState } from "react";
import { backend_url } from "../App";
import TailoringOrderDetail from "../Components/TailoringOrderDetail/TailoringOrderDetail";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import "./CSS/TailoringOrders.css";

const STATUS_CLASS = {
  "New": "to-status-new",
  "In Progress": "to-status-progress",
  "Completed": "to-status-completed",
  "Delivered": "to-status-delivered",
  "Cancelled": "to-status-cancelled",
};

const TailoringOrders = () => {
  const [orders, setOrders] = useState([]);
  const [customers, setCustomers] = useState([]);
  const [search, setSearch] = useState("");
  const [selectedId, setSelectedId] = useState(undefined);
  const [loading, setLoading] = useState(true);
  const [newCustomerId, setNewCustomerId] = useState("");

  useEffect(() => {
    fetchOrders();
    fetch(`${backend_url}/api/customers`).then((r) => r.json()).then((d) => {
      if (d.success) setCustomers(d.customers);
    }).catch(() => {});
  }, []);

  const fetchOrders = async (query = "") => {
    setLoading(true);
    try {
      const res = await fetch(`${backend_url}/api/tailoring-orders${query ? `?search=${encodeURIComponent(query)}` : ""}`);
      const data = await res.json();
      setOrders(data.success ? data.orders : []);
    } catch {
      setOrders([]);
    } finally {
      setLoading(false);
    }
  };

  const handleSearch = (e) => {
    setSearch(e.target.value);
    fetchOrders(e.target.value);
  };

  const startNewOrder = async () => {
    if (!newCustomerId) {
      toast.error("Pick a customer first");
      return;
    }
    try {
      const res = await fetch(`${backend_url}/api/tailoring-orders`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ customerId: newCustomerId }),
      });
      const data = await res.json();
      if (!data.success) throw new Error();
      toast.success("Order created");
      setSelectedId(data.order._id);
      fetchOrders(search);
    } catch {
      toast.error("Failed to create order");
    }
  };

  const handleDelete = async (id, e) => {
    e.stopPropagation();
    if (!window.confirm("Remove this order?")) return;
    try {
      const res = await fetch(`${backend_url}/api/tailoring-orders/${id}`, { method: "DELETE" });
      const data = await res.json();
      if (!data.success) throw new Error();
      toast.success("Order removed");
      setOrders((prev) => prev.filter((o) => o._id !== id));
    } catch {
      toast.error("Failed to remove order");
    }
  };

  return (
    <div className="to-page">
      <div className="to-header">
        <div className="to-title-group">
          <h2 className="to-title">📋 Order Management</h2>
          <span className="to-count-badge">{orders.length} orders</span>
        </div>

        <div className="to-search-wrap">
          <span className="to-search-icon">🔍</span>
          <input type="text" placeholder="Search by order ID or customer..." value={search} onChange={handleSearch} />
        </div>

        <div className="to-new-order">
          <select value={newCustomerId} onChange={(e) => setNewCustomerId(e.target.value)}>
            <option value="">Select customer…</option>
            {customers.map((c) => (
              <option key={c.id} value={c.id}>{c.name} {c.customerId ? `(${c.customerId})` : ""}</option>
            ))}
          </select>
          <button className="to-add-btn" onClick={startNewOrder}>+ New Order</button>
        </div>
      </div>

      {loading ? (
        <p className="to-empty-msg">Loading…</p>
      ) : orders.length === 0 ? (
        <div className="to-empty-msg">
          <div className="to-empty-icon">📋</div>
          No orders yet — pick a customer above and start one.
        </div>
      ) : (
        <div className="to-table-wrapper">
          <table>
            <thead>
              <tr>
                <th>Order ID</th>
                <th>Customer</th>
                <th>Type</th>
                <th>Occasion</th>
                <th>Priority</th>
                <th>Delivery Date</th>
                <th>Status</th>
                <th></th>
              </tr>
            </thead>
            <tbody>
              {orders.map((o) => (
                <tr key={o._id} className="to-row-clickable" onClick={() => setSelectedId(o._id)}>
                  <td className="to-order-id">{o.orderId}</td>
                  <td>{o.customerId?.name || "—"}</td>
                  <td>{o.orderType}</td>
                  <td>{o.occasion}</td>
                  <td>{o.priorityLevel}</td>
                  <td>{o.deliveryDate ? new Date(o.deliveryDate).toLocaleDateString() : "—"}</td>
                  <td><span className={`to-status-pill ${STATUS_CLASS[o.status] || ""}`}>{o.status}</span></td>
                  <td><button className="to-del-btn" onClick={(e) => handleDelete(o._id, e)}>✕</button></td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}

      {selectedId !== undefined && (
        <TailoringOrderDetail
          orderId={selectedId}
          onClose={() => setSelectedId(undefined)}
          onSaved={() => fetchOrders(search)}
        />
      )}
      <ToastContainer position="top-right" autoClose={2500} />
    </div>
  );
};

export default TailoringOrders;
